import { styled } from '@grupoboticario/flora';

export const PaymentStyles = {
  Component: styled('div', {
    margin: '$0 0 $6 0',
  }),

  Card: styled('div', {
    width: '100%',
    backgroundColor: '$backgroundPrimary',
    padding: '$4',

    '.item-payment': {
      paddingBottom: '$3',
      paddingTop: '$3',
      borderBottom: '1px solid $nonInteractiveOutline',
    },

    '.without-border': {
      borderBottom: 'none',
    },
  }),
};
